<template>
  <div v-if="item">
    <div v-if="role" class="role">{{ role }}</div>
    <div class="person">
      <div>
        <p>{{ item.name }}</p>
        <span>{{ item.mobile | maskMobile }}</span>
      </div>
      <div class="card">
        <p>身份证</p>
        <span>{{ item.card | maskCard }}</span>
      </div>
      <div v-if="errmsg" class="error">
        <img src="@/assets/images/icon_error.png" />
        <span>{{ errmsg }}</span>
      </div>
    </div>
    <p class="delete" @click="deleteItem(item)">删除</p>
  </div>
</template>

<script>
import { isNumber } from '@/utils'
import { Msgbox } from 'kf-component-vue'

export default {
  props: {
    item: {
      type: Object,
      default: () => null
    },
    isGuardian: {
      type: Boolean,
      default: false
    },
    isChild: {
      type: String,
      default: ''
    }
  },
  computed: {
    errmsg() {
      //监护人只需要判断成年了和实名
      if (this.isGuardian) {
        if (this.item.insureIsAdult === 0) {
          return '监护人未成年'
        }
        if (this.item.insureStatus === 0) {
          return '领取人实名检测不通过'
        }
        return
      }
      if (this.item.insureStatus === 0) {
        return '领取人实名检测不通过'
      }
      if (this.item.insureIsAdult === 0) {
        if (!this.isChild) {
          return '领取人未成年'
        }
      }
      if (this.item.insureIsAdult === 1) {
        if (this.isChild) {
          return '领取人已成年'
        }
      }
      if (this.item.insureIsOk === 1) {
        return this.item.insureErrMsg
      }
    },
    role() {
      if (this.isGuardian && this.item && this.item.card) {
        const length = this.item.card.length
        const number = +this.item.card.substring(length - 2, length - 1)
        if (isNumber(number)) {
          if (number % 2 === 0) {
            return '母亲'
          } else {
            return '父亲'
          }
        }
        return ''
      }
    }
  },
  methods: {
    deleteItem(item) {
      Msgbox({
        title: '',
        message: '是否确认删除该领取人信息？',
        confirmButtonText: '确定',
        showCancelButton: true,
        confirmButtonClass: 'confirmButton',
        type: 'confirm',
        action: msgbox => {
          this.$emit('delete', {
            isGuardian: this.isGuardian,
            item
          })
        }
      })
    }
  },
  filters: {
    maskMobile(str) {
      return `${str.substr(0, 3)}****${str.substr(-4)}`
    },
    maskCard(str) {
      return `${str.substr(0, 4)}**********${str.substr(-4)}`
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.person-wrapper {
  padding: rem(24px) 0;
  // margin-left: rem(32px);
  display: flex;
  border-bottom: rem(1px) #eee solid;
  align-items: center;
  &:last-child {
    border-width: 0;
  }
  .role {
    color: #ff5900;
    width: rem(56px);
    height: rem(28px);
    margin-left: rem(32px);
    line-height: rem(28px);
    text-align: center;
    font-size: rem(20px);
    border-radius: rem(4px);
    border: rem(1px) solid #ff5900;
  }
  .radio {
    width: rem(40px);
    height: rem(40px);
  }
  .tran {
    width: rem(40px);
  }
  .delete {
    font-size: rem(26px);
    margin-right: rem(32px);
    color: red;
  }
  .person {
    flex: 1;
    margin-left: rem(36px);
    > div {
      font-size: rem(26px);
      display: flex;

      > p {
        color: #666666;
        width: rem(130px);
      }
      span {
        color: #262626;
      }
    }
    .card {
      margin-top: rem(12px);
    }
    .error {
      margin-top: rem(16px);
      display: flex;
      align-items: center;
      img {
        width: rem(24px);
        height: rem(24px);
        margin-right: rem(8px);
      }
      span {
        color: #ff2f25;
        margin-top: rem(2px);
        line-height: 1;
        font-size: rem(22px);
      }
    }
  }
}
</style>
